import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navigate, Route, Routes } from "react-router-dom";
import FullWordModel from "./common/FullWordModel";
import Admin from "./components/admin/Admin";
import { usePreference } from "./context/UserContext";
import LoginModel from "./components/login/LoginModel";
import SignUpModel from "./components/signup/SignUpModel";
import CommentModel from "./common/CommentModel";
import Feedback from "./components/Feedback";
import AdminFeedback from "./components/AdminFeedback";
import UserProfile from "./components/EditProfile/UserProfile";

import "./assets/css/styles.css";

import NewNavbar from "./components/NewNavbar";
import NewContent from "./components/NewContent";

import NewUI from "./components/newplayer/NewUI";
import PayPalModal from "./components/paypal/PaypalModel";
import UserRankings from "./components/statistics/UserRankings";
import ForgotPasswordModal from "./components/login/ForgotPasswordModal";
import Extra from "./common/Extra";
import UserActivityTracker from "./components/statistics/UserActivityTracker";
import NotFound from "./common/NotFound";
import MyQuizzes from "./components/myquizzes/MyQuizzes";
import LandingPage from "./components/login/LandingPage";
import AllSubcategories from "./components/SubCategories";
import GameBoard from "./Games/GameBoards/GameBoard";
import GameCard from "./Games/GameBoards/GameCard";
import DraggableLetter from "./Games/DraggableLetter";
import GamesList from "./Games/GamePage";
import DroppableBox from "./Games/DroppableBox";
import WordSearch from "./Games/GameBoards/WordSearch";
import FindWords from "./Games/GameBoards/FindWords";
import SpellCheckGame from "./Games/GameBoards/SpellCheckGame";
import DiscourseForums from "./components/DiscourseForums";
import GamesComingSoon from "./Games/GamesComingSoon";
import Users from "./components/Users";
import BeeFlyArround from "./common/BeeFlyAround";
import BeeFlyArround2 from "./common/BeeFlyArround2";
import ModuleGrade from "./components/home/ModuleGrade";
import Games from "./Games/Games";
import MaintenancePopup from "./components/MaintenancePopup";
import SpellGames from "./Games/SpellGames";
import WordViewer from "./Games/WordViewer";
import RotatePuzzle from "./Games/RotatePuzzle";
import ImageSlider from "./components/statistics/ImageSlider";
import TableData from "./Games/TableData";
import PuzzlePages from "./Games/PuzzlePages";
import TypeFastWord from "./Games/TypeFastWords";
import AllWordsTable from "./components/login/AllWordsTable";
import useTrackPageView from "./common/UseTrackFirstVisit";
import WordTable from "./components/login/WordTable";
import FeatureTour from "./common/FeatureTour";
import PackagesCRUD from "./components/superadmin/PackagesCRUD";
import PromoCodesCRUD from "./components/superadmin/PromoCodesCRUD";
import ContactForm from "./components/signup/ContactForm";
// import BeeGame from "./Games/BeeGame";
// import GameCard from "./Games/GameBoards/GameCard";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    isLoginOpen,
    updateIsLoginOpen,
    isSignUpOpen,
    updateIsSignUpOpen,
    searchedId,
    updateSearchedId,
    isForgotPwdOpen,
    upateForgotPwdOpen,
    isMaintenanceOpen,
    updateIsMaintenanceOpen,
  } = usePreference();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const updateIsOpen = (i) => {
    setIsOpen(i);
  };
  const [selectedid, setSelectedId] = useState(0);
  const updateSelectedId = (s) => {
    setSelectedId(s);
    // alert(s);
  };

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const [quizId, setQuizId] = useState(0);
  const updateQuizId = (value) => {
    setQuizId(value);
  };

  const [showModal, setShowModal] = useState(false); // State to control modal visibility

  const updateShowMOdal = (value) => {
    setShowModal(value);
  };
useTrackPageView();

const steps = [
  { target: "#nav-link", content: "Dashboard: at-a-glance KPIs." },

];
  return (
    <>
      <div
        style={{
          fontFamily: "Ubuntu, sans-serif",
        }}
      >
      
        <NewNavbar setShowModal={updateShowMOdal} />
        <section id="hero">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/comingsoon" element={<GamesComingSoon />} />
            {/* <Route path="/slider" element={<ImageSlider/>} /> */}
            <Route
              path="/users"
              element={<PrivateRoute element={<Users />} />}
            />
            {/* <Route path="/games" element={<GamesList />} /> */}
            <Route path="/games" element={<PuzzlePages />} />
            {/* <Route path="/bee" element={<BeeGame />} /> */}
            <Route
              path="/wordsdata"
              element={<PrivateRoute element={<TableData />} />}
            />
            <Route
              path="/admin"
              element={<PrivateRoute element={<Admin />} />}
            />
            <Route
              path="/feedbacks"
              element={<PrivateRoute element={<AdminFeedback />} />}
            />
            <Route path="/learn" element={<ModuleGrade />} />
            <Route path="/games/game-board" element={<GameBoard />} />
            <Route path="/games/spelling-game" element={<Games />} />
            <Route path="/games/type-fast-words" element={<TypeFastWord />} />
            <Route path="/fun" element={<SpellGames />} />
            <Route path="/searchwords" element={<WordTable />} />
            <Route path="/wordtable" element={<AllWordsTable />} />
            <Route path="/learn-words" element={<WordViewer />} />
            <Route path="/games/word-search" element={<WordSearch />} />
            <Route path="/rotate-puzzle" element={<RotatePuzzle />} />
            <Route path="/games/find-words" element={<FindWords />} />
            <Route path="/games/spell-check" element={<SpellCheckGame />} />
            <Route path="/discourseforums" element={<DiscourseForums />} />
            {/* <Route path="/" element={<NewContent />} /> */}
            {/* <Route path="/newwordpacks" element={<CategoryDisplay/>} /> */}
            <Route path="/categories" element={<AllSubcategories />} />
            <Route path="" element={<NewContent />} />
            <Route path="/playquiz/:id" element={<NewUI />} />
            {/* <Route path="/contactform" element={<ContactForm/>} /> */}

            <Route
              path="/ranks"
              element={<UserRankings setShowModal={updateShowMOdal} />}
            />
            {/* <Route path="/profile" element={<UserProfile />} /> */}
            <Route path="/extra" element={<Extra />} />
            <Route path="/statistics" element={<UserActivityTracker />} />

            <Route path="/myquizzes" element={<MyQuizzes />} />
            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
            <Route
              path="/not-authorized"
              element={<NotAuthorized signin={updateIsSignUpOpen} />}
            />

            <Route path="/packages" element={<PackagesCRUD />} />
            <Route path="/promocode" element={<PromoCodesCRUD />} />

          </Routes>
        </section>
      </div>
      {/* ...your UI Guded tour... */}
       {/* <FeatureTour version="2025.08.254" steps={steps} />  */}
      {/* Optional button to re-open */}
       {/* <button onClick={() => window.startTourAgain?.()}>Start tour</button>  */}
   
      <FullWordModel
        open={isOpen}
        updateIsOpen={setIsOpen}
        selectedid={selectedid}
      />
      <LoginModel open={isLoginOpen} updateIsOpen={updateIsLoginOpen} />
      <SignUpModel open={isSignUpOpen} updateIsOpen={updateIsSignUpOpen} />
      <CommentModel />
      <PayPalModal />
      <ForgotPasswordModal
        IsForgotPwd={isForgotPwdOpen}
        upateForgotPwd={upateForgotPwdOpen}
      />
      <Feedback showModal={showModal} setShowModal={updateShowMOdal} />
      <MaintenancePopup
        open={isMaintenanceOpen}
        setShowModal={updateIsMaintenanceOpen}
      />
    </>
  );
}

// Simulating an authentication check (you can use context, Redux, or other state management here)
const isAuthenticatedSuperAdmin = () => {
  // Replace this with your actual authentication check (e.g., token validation, user session check)
  return localStorage.getItem("userrole") === "SuperAdmin";
};

const isAuthenticatedAdmin = () => {
  return localStorage.getItem("userrole") === "Admin";
};

// Private Route Component
const PrivateRoute = ({ element }) => {
  return isAuthenticatedSuperAdmin() || isAuthenticatedAdmin() ? (
    element
  ) : (
    <Navigate to="/not-authorized" />
  );
};

const NotAuthorized = ({ signin }) => (
  <div style={{ textAlign: "center", marginTop: "50px" }}>
    <h1>Un-authorized Access</h1>
    <p>
      Please{" "}
      <a style={{ cursor: "pointer" }} onClick={signin}>
        signin
      </a>{" "}
      to access this page
    </p>
    <a href="/" style={{ textDecoration: "none", color: "blue" }}>
      Go back to Home
    </a>
  </div>
);

export default App;

{
  /* <Route path="/not-authorized" element={<NotAuthorized signin={openSignIn} />} />
const NotAuthorized = ({ signin }) => (
  <div style={{ textAlign: "center", marginTop: "50px" }}>
    <h1>Un-authorized Access</h1>
    <p>Please <a style={{ cursor: 'pointer' }} onClick={signin} >signin</a> to access this page</p>
    <a href="/" style={{ textDecoration: "none", color: "blue" }}>
      Go back to Home
    </a>
  </div>
);            <Route path="/learn-trading-options" element={<PrivateRoute element={<OPDataTable />} />} />
// Simulating an authentication check (you can use context, Redux, or other state management here)
  const isAuthenticated = () => {
    // Replace this with your actual authentication check (e.g., token validation, user session check)
    return localStorage.getItem('username') == null ? false : true;
  };

  // Private Route Component
  const PrivateRoute = ({ element }) => {
    return isAuthenticated() ? element : <Navigate to="/not-authorized" />;
  }; */
}
